/* =========================================================================
   My Prolearning — Global chrome
   Header scroll shadow · topbar close · mobile drawer · cart drawer (AJAX)
   Site-wide add-to-cart: any form with class "mpl-add-form" adds via AJAX
   and opens the cart drawer (no full-page redirect).
   ========================================================================= */
(function () {
  "use strict";
  var $ = function (s, c) { return (c || document).querySelector(s); };

  /* ---------------- topbar close ---------------- */
  var topClose = $("#mplTopClose");
  if (topClose) {
    if (localStorage.getItem("mpl_topbar_closed") === "1") document.body.classList.add("mpl-topbar-hidden");
    topClose.addEventListener("click", function () {
      document.body.classList.add("mpl-topbar-hidden");
      try { localStorage.setItem("mpl_topbar_closed", "1"); } catch (e) {}
    });
  }

  /* ---------------- mobile drawer ---------------- */
  var drawer = $("#mplDrawer"), scrim = $("#mplScrim");
  function setDrawer(open) {
    if (drawer) drawer.classList.toggle("is-open", open);
    if (scrim) scrim.classList.toggle("is-open", open);
  }
  var burger = $("#mplBurger"), drawerClose = $("#mplDrawerClose");
  if (burger) burger.addEventListener("click", function () { setDrawer(true); });
  if (drawerClose) drawerClose.addEventListener("click", function () { setDrawer(false); });
  if (scrim) scrim.addEventListener("click", function () { setDrawer(false); });

  /* ---------------- header scroll shadow + smart hide/show ----------------
     Géré en inline dans sections/mpl-header.liquid (embarqué avec la section
     pour un déploiement fiable, et repli automatique si le JS n'est pas chargé). */

  /* ================= CART DRAWER ================= */
  var cd       = $("#mplCartDrawer");
  var cdScrim  = $("#mplCartScrim");
  var cdBody   = $("#mplCartBody");
  var cdTotal  = $("#mplCartTotal");
  var cdQty    = $("#mplCartQty");
  var countEl  = $("#mplCartCount");
  var cartBtn  = $("#mplCartBtn");

  function money(cents, currency) {
    try { return new Intl.NumberFormat("fr-FR", { style: "currency", currency: currency || "EUR" }).format((cents || 0) / 100); }
    catch (e) { return "€" + ((cents || 0) / 100).toFixed(2).replace(".", ","); }
  }
  function setCount(n) {
    if (countEl) {
      countEl.textContent = n;
      countEl.style.display = n > 0 ? "" : "none";
      countEl.classList.remove("bump"); void countEl.offsetWidth; countEl.classList.add("bump");
    }
    if (cdQty) { cdQty.textContent = n; cdQty.classList.remove("bump"); void cdQty.offsetWidth; cdQty.classList.add("bump"); }
    if (cartBtn) cartBtn.setAttribute("aria-label", "Panier : " + n + " article(s)");
  }
  function openCart() {
    if (!cd) return;
    cd.classList.add("open"); if (cdScrim) cdScrim.classList.add("open");
    cd.setAttribute("aria-hidden", "false"); document.body.style.overflow = "hidden";
    var c = document.getElementById("mplCartClose"); if (c) setTimeout(function () { c.focus(); }, 60);
  }
  function closeCart() { if (cd) { cd.classList.remove("open"); if (cdScrim) cdScrim.classList.remove("open"); cd.setAttribute("aria-hidden", "true"); document.body.style.overflow = ""; } }

  function renderShip(cart) {
    var ship = document.getElementById("mplCartShip");
    if (!ship) return;
    var fsQty = parseInt(cd && cd.getAttribute("data-fs-qty"), 10) || 0;
    if (fsQty <= 0) { ship.innerHTML = ""; ship.style.display = "none"; return; }
    ship.style.display = "";
    var remaining = fsQty - cart.item_count;
    var pct = Math.min(100, Math.round((cart.item_count / fsQty) * 100));
    var msg = remaining > 0
      ? "Plus que <b>" + remaining + "</b> article" + (remaining > 1 ? "s" : "") + " pour la <b>livraison offerte</b> !"
      : "🎉 Tu bénéficies de la <b>livraison offerte</b> !";
    ship.innerHTML = '<p class="mpl-cart-ship__msg' + (remaining > 0 ? "" : " is-done") + '">' + msg + "</p>" +
      '<div class="mpl-cart-ship__track"><span class="mpl-cart-ship__fill" style="width:' + pct + '%"></span></div>';
  }

  var trashSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/></svg>';

  function renderCart(cart) {
    var empty = !cart.items || !cart.items.length;
    if (cd) cd.classList.toggle("is-empty", empty);
    setCount(cart.item_count);
    if (cdTotal) { cdTotal.textContent = money(cart.total_price, cart.currency); cdTotal.classList.remove("bump"); void cdTotal.offsetWidth; cdTotal.classList.add("bump"); }
    renderShip(cart);
    var live = document.getElementById("mplCartLive");
    if (live) live.textContent = "Panier mis à jour, " + cart.item_count + " article(s).";
    if (!cdBody) return;
    if (empty) {
      cdBody.innerHTML = '<div class="mpl-cart-empty">' +
        '<div class="mpl-cart-empty__ill" aria-hidden="true"><svg viewBox="0 0 120 120" fill="none"><circle cx="60" cy="60" r="56" fill="#F4EFE3"/><path d="M34 42h54l-5 34a6 6 0 0 1-6 5H45a6 6 0 0 1-6-5l-5-34Z" fill="#fff" stroke="#1F2A4D" stroke-width="3"/><path d="M48 42a12 12 0 0 1 24 0" stroke="#E94633" stroke-width="3" stroke-linecap="round"/><circle cx="50" cy="92" r="5" fill="#1F2A4D"/><circle cx="74" cy="92" r="5" fill="#1F2A4D"/></svg></div>' +
        '<p class="mpl-cart-empty__txt">Ton panier est vide.</p>' +
        '<a class="mpl-chrome-btn mpl-chrome-btn--primary" href="/">Découvrir nos flashcards</a></div>';
      return;
    }
    cdBody.innerHTML = cart.items.map(function (it, i) {
      var variant = (it.variant_title && it.variant_title !== "Default Title") ? '<span class="mpl-ci-variant">' + it.variant_title + "</span>" : "";
      var img = it.image
        ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2") + '" alt="" width="72" height="72" loading="lazy">'
        : '<span class="mpl-ci-thumb__ph" aria-hidden="true"></span>';
      var onSale = it.original_line_price > it.final_line_price;
      var price = '<span class="mpl-ci-total">' + money(it.final_line_price, cart.currency) + "</span>" +
        (onSale ? '<span class="mpl-ci-was">' + money(it.original_line_price, cart.currency) + "</span>" : "");
      return '<div class="mpl-ci" data-line="' + (i + 1) + '" style="--i:' + i + '">' +
        '<a class="mpl-ci-thumb" href="' + it.url + '">' + img + "</a>" +
        '<div class="mpl-ci-info">' +
          '<a class="mpl-ci-title" href="' + it.url + '">' + it.product_title + "</a>" + variant +
          '<span class="mpl-ci-unit">' + money(it.final_price, cart.currency) + " / unité</span>" +
          '<div class="mpl-ci-controls"><div class="mpl-ci-qty">' +
            '<button type="button" class="mpl-ci-step" data-action="dec" aria-label="Diminuer">−</button>' +
            '<span class="mpl-ci-q">' + it.quantity + "</span>" +
            '<button type="button" class="mpl-ci-step" data-action="inc" aria-label="Augmenter">+</button></div>' +
            '<button type="button" class="mpl-ci-remove" data-action="remove" aria-label="Retirer">' + trashSvg + "</button></div>" +
        "</div>" +
        '<div class="mpl-ci-price">' + price + "</div></div>";
    }).join("");
  }
  function fetchCart() { return fetch("/cart.js", { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); }); }
  function changeLine(line, qty) {
    if (cd) cd.classList.add("is-loading");
    return fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart)
      .catch(function () {}).then(function () { if (cd) cd.classList.remove("is-loading"); });
  }

  if (cdBody) {
    cdBody.addEventListener("click", function (e) {
      var b = e.target.closest("[data-action]"); if (!b) return;
      var row = e.target.closest(".mpl-ci"); if (!row) return;
      var line = parseInt(row.getAttribute("data-line"), 10);
      var q = parseInt(row.querySelector(".mpl-ci-q").textContent, 10) || 1;
      var act = b.getAttribute("data-action");
      if (act === "inc") changeLine(line, q + 1);
      else if (act === "dec") changeLine(line, Math.max(0, q - 1));
      else { row.classList.add("removing"); setTimeout(function () { changeLine(line, 0); }, 220); }
    });
  }

  /* discount code from the drawer */
  var promoApply = $("#mplDrawerPromoApply");
  if (promoApply) promoApply.addEventListener("click", function () {
    var f = $("#mplDrawerPromo"); var code = f && f.value ? f.value.trim() : "";
    if (code) window.location.href = "/discount/" + encodeURIComponent(code) + "?redirect=/cart";
  });
  var cdClose = $("#mplCartClose");
  if (cdClose) cdClose.addEventListener("click", closeCart);
  if (cdScrim) cdScrim.addEventListener("click", closeCart);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeCart(); setDrawer(false); } });
  if (cartBtn) cartBtn.addEventListener("click", function (e) {
    e.preventDefault();
    fetchCart().then(function (cart) { renderCart(cart); openCart(); }).catch(function () { window.location.href = cartBtn.getAttribute("href") || "/cart"; });
  });

  /* ---------------- site-wide AJAX add-to-cart ---------------- */
  var checkSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains("mpl-add-form")) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (btn && btn.disabled) return;
    var original = btn ? btn.innerHTML : "";
    if (btn) btn.disabled = true;
    fetch("/cart/add.js", { method: "POST", headers: { "Accept": "application/json" }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        renderCart(cart); openCart();
        if (btn) { btn.innerHTML = checkSvg + "Ajouté"; btn.style.background = "var(--mpl-green, #4FBE5B)";
          setTimeout(function () { btn.innerHTML = original; btn.style.background = ""; btn.disabled = false; }, 1400); }
      })
      .catch(function () { form.submit(); });
  });

  /* prime the count/drawer with the current cart */
  fetchCart().then(renderCart).catch(function () {});

  /* expose a tiny API */
  window.MPLChrome = { openCart: openCart, closeCart: closeCart, refresh: function () { return fetchCart().then(renderCart); } };
})();
